<template>
	<div class="width-100 display-flex flex-column">
		<div v-if="!noSwitch" class="width-100 display-flex flex-row flex-align-center flex-justify-space-between">
			<div class="display-flex flex-column">
				<div class="field-text">{{ title }}</div>
				<div v-if="description" class="description-text">{{ description }}</div>
			</div>
			<AppSwitch :disabled="isSwitchDisabled" class="swtch drk sml mr-n1" v-model="switchModelLocal" />
		</div>
		<BasicTextField class="mb-5" v-if="showTextInput" :placeholder="placeholder" v-model="textFieldValueLocal" small />
	</div>
</template>
<script>
import debounce from 'lodash/debounce';
export default {
	name: 'SettingSwitch',
	props: {
		title: { type: String },
		noSwitch: { type: Boolean },
		description: { type: String },
		placeholder: { type: String },
		switchValue: { type: Boolean },
		textFieldValue: { type: String },
		isSwitchDisabled: { type: Boolean },
	},
	computed: {
		showTextInput() {
			if (this.noSwitch) {
				return true;
			}
			return this.switchModelLocal && this.textFieldValue !== undefined;
		},
		switchModelLocal: {
			get() {
				return this.switchValue;
			},
			set(value) {
				this.$emit('update:switchValue', value);
			},
		},
		textFieldValueLocal: {
			get() {
				return this.textFieldValue;
			},
			set: debounce(function (value) {
				this.$emit('update:textFieldValue', value);
			}, 500),
		},
	},
};
</script>
<style scoped lang="scss">
.field-text {
	font-size: 14px;
	font-weight: normal;
	color: var(--primary-font-color);
}

.description-text {
	font-size: 12px;
	font-weight: normal;
	color: var(--secondary-font-color);
}
</style>
